import { QueryClient, defaultShouldDehydrateQuery } from "@tanstack/react-query";
import { shouldRetryEndpoint } from "./shouldRetryEndpoint";
export var buildQueryClient = function() {
    return new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: false,
                retry: shouldRetryEndpoint
            },
            dehydrate: {
                shouldDehydrateQuery: function(query) {
                    return defaultShouldDehydrateQuery(query) || query.state.status === "pending";
                }
            }
        }
    });
};
